import $ = require("jquery");
import ko = require("knockout");
import _ = require("underscore");
import Service = require("./Service");
import Controls = require("./Controls");
import AddEditDialogOptions = require("./IAddEditDialogOptions");
require("datatables.net-bs4");
import "./jquery.antiforgerytoken.ts";
import { Api } from "datatables.net-bs4";

import validationOptions = require("./JQueryValidationOptions");

validationOptions.JQueryValidationOptions.register();

export = AddEditDialog;

module AddEditDialog {
    export interface AddEditDialog {
        setEntityDataTable: (table: Api) => void;
        deleteEntity: (entityId, index, sourceButton, deleteButtonSelector?, domRowIndex?) => void;
        editEntity: (entityId, entityIndex, activatingElement?) => void;
    }

    export function run(options: AddEditDialogOptions) {
        var opts: AddEditDialogOptions = {
            deleteInfoFields: [],
            entityName: "Entity",
            messageContainerId: null,
            deleteActionText: "Delete Entity",
            archiveActionText: "Archive Entity",
            reassignActionText: "Delete Entity and Reassign Children",
            deleteDialogId: "entityDeleteDialog",
            deleteEntityDialogTitle: "Delete",
            deleteEntityDialogIcon: "delete",
            entityDeletedCallback: null,
            supportsDelete: true,
            supportsArchive: true,
            supportsReassign: true,

            editDialogId: "entityEditDialog",
            editDialogTitleId: "entityEditDialogTitle",
            editFormId: "entityEditForm",
            editDialogGridIndexInputId: "dataIndex",
            editDialogCancelButtonId: "cancelButton",
            fnPopulateEditFormWithEntity: entity => { },
            addEntityDialogTitle: "Add New",
            addEntityDialogIcon: "add",
            editEntityDialogTitle: "Edit",
            editEntityDialogIcon: "edit",
            entityUpdatedCallback: null,
            entityDeleteSuccessCallback: null,
            dialogDismissCallback: null,

            addEntityButtonId: "btnAddEntity",

            entityDataTable: null,

            archiveUrl: '',
            deleteUrl: '',
            getDeleteInfoUrl: '',
            saveUrl: '',
            errorPlacementFunction: null
        };

        $.extend(opts, options);

        var that: any = {};
        that.setEntityDataTable = (table: Api) => {
            opts.entityDataTable = table;
        };

        var deleteInfo: any = {
            availableEntities: ko.observableArray([]),
            deleteAction: ko.observable(),
            reassignId: ko.observable(),
            entityDeleteId: ko.observable(),
            entityIndex: ko.observable(),
            takingAction: ko.observable(false),
            hasDependencies: ko.observable(false)
        };
        var i: number;
        for (i = 0; i < opts.deleteInfoFields.length; i += 1) {
            deleteInfo[opts.deleteInfoFields[i]] = ko.observable();
        }

        deleteInfo.actionDelete = ko.computed(() => (deleteInfo.deleteAction() === "Delete"));
        deleteInfo.actionArchive = ko.computed(() => (deleteInfo.deleteAction() === "Archive"));
        deleteInfo.actionReassign = ko.computed(() => (deleteInfo.deleteAction() === "Reassign"));
        deleteInfo.unsuccessfulReassign = ko.computed(() => (deleteInfo.actionReassign() && deleteInfo.availableEntities().length === 0));
        deleteInfo.canTakeAction = ko.computed(() => {
            var di = deleteInfo;
            if (di.takingAction()) {
                return false;
            }
            if (di.actionDelete() || (di.actionReassign() && !di.unsuccessfulReassign()) || di.actionArchive()) {
                return true;
            }
            return false;
        });
        deleteInfo.takeActionText = ko.computed(() => {
            if (deleteInfo.actionDelete()) {
                return opts.deleteActionText;
            } else if (deleteInfo.actionArchive()) {
                return opts.archiveActionText;
            } else {
                return opts.reassignActionText;
            }
        });

        function deleteComplete(actionPerformed) {
            var message;
            message = null;
            if (opts.messageContainerId) {
                if (actionPerformed === "Delete") {
                    message = opts.entityName + " Deleted";
                } else if (actionPerformed === "Archive") {
                    message = opts.entityName + " Archived";
                } else if (actionPerformed === "Reassign") {
                    message = opts.entityName + " deleted and child items reassigned";
                }
                if (message) {
                    Controls.displaySuccessMessage(message);
                }
            }

            if (opts.entityDeletedCallback) {
                opts.entityDeletedCallback(actionPerformed);
            }
        }
        function updateComplete(updateResult) {
            var message = opts.entityName + " updated";
            Controls.displaySuccessMessage(message);

            if (opts.entityUpdatedCallback) {
                opts.entityUpdatedCallback(updateResult);
            }
        }

        function cleanUpDeleteAction(di, error, result) {
            if (result) {
                $("#" + opts.deleteDialogId).modal("hide");
            }
            di.takingAction(false);
            if (!error) {
                deleteComplete(di.deleteAction());
            }

        }

        function flashRowAtIndex(index: number) {
            console.log("flashing row at index " + index);
            Controls.highlightRow(opts.entityDataTable.settings().row(index).node());
        }

        function actuallyDeleteEntity(entityId, reassignmentId, entityIndex, callback) {
            $.postAntiForgery(opts.deleteUrl, { entityId: entityId, reassignDependencies: reassignmentId }, result => {
                callback(null, result);
            }).fail(errorDetails => {
                callback(errorDetails);
                Service.reportMessageResultError(errorDetails);
            }).done(() => {
                if (opts.entityDeleteSuccessCallback)
                    opts.entityDeleteSuccessCallback(entityId, reassignmentId);

                if (opts.entityDataTable) {
                    opts.entityDataTable.settings().row(entityIndex).remove();
                    opts.entityDataTable.draw();
                };
            });
        }

        deleteInfo.takeAction = (di) => {
            di.takingAction(true);
            var idx = di.entityIndex();
            if (di.actionDelete() && opts.supportsDelete) {
                actuallyDeleteEntity(di.entityDeleteId(), null, idx, (err, result) => {
                    cleanUpDeleteAction(di, err, result);
                });
            } else if (di.actionArchive() && opts.supportsArchive) {
                $.postAntiForgery(opts.archiveUrl, { entityId: di.entityDeleteId() }, result => {
                    if (result && result.Successful) {
                        if (opts.entityDataTable) {
                            //var data = opts.entityDataTable.fnGetData(idx);
                            var data : any = opts.entityDataTable.settings().row(idx).data();
                            data.Active = false;
                            //opts.entityDataTable.fnUpdate(data, idx);
                            opts.entityDataTable.settings().row(idx).data(data);
                            flashRowAtIndex(idx);
                        }
                        $("#" + opts.deleteDialogId).modal("hide");
                    } else {
                        Service.reportMessageResultError(result);
                    }
                    di.takingAction(false);
                    deleteComplete(di.deleteAction());
                }).fail(errorDetails => {
                    di.takingAction(false);
                    Service.reportMessageResultError(errorDetails);
                });
            } else if (di.actionReassign() && opts.supportsReassign) {
                actuallyDeleteEntity(di.entityDeleteId(), di.reassignId(), idx, (err, result) => {
                    cleanUpDeleteAction(di, err, result);
                });
            }
        };

        deleteInfo.cancelDelete = () => {
            $("#" + opts.deleteDialogId).modal("hide");
            deleteInfo.takingAction(false);
        };


        function mightHaveDependencies(entityInfo) {
            var fieldName;
            if (entityInfo && opts.deleteInfoFields.length > 0) {
                for (i = 0; i < opts.deleteInfoFields.length; i += 1) {
                    fieldName = opts.deleteInfoFields[i];
                    if (entityInfo[fieldName] !== undefined && _.isFinite(entityInfo[fieldName])) {
                        if (entityInfo[fieldName] > 0) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        that.deleteEntity = (entityId, index, sourceButton, sourceButtonSelector, domRowIndex) => {
            lastFocus = sourceButton;
            deleteRowButtonSelector = sourceButtonSelector;
            deleteRowDOMIndex = domRowIndex;
            Controls.setBusy(sourceButton);
            index = parseInt(index, 10);
            $.post(opts.getDeleteInfoUrl, { entityId: entityId }, result => {
                if (result.EventCount === 0) {
                    actuallyDeleteEntity(entityId, null, index, (err, deleteResult) => { Controls.clearBusy(sourceButton); });
                } else {
                    deleteInfo.entityDeleteId(entityId);
                    deleteInfo.entityIndex(index);

                    var fieldName;
                    for (i = 0; i < opts.deleteInfoFields.length; i += 1) {
                        fieldName = opts.deleteInfoFields[i];
                        if (result[fieldName] !== undefined) {
                            deleteInfo[fieldName](result[fieldName]);
                        }
                    }


                    deleteInfo.availableEntities(result.OtherEntities);
                    deleteInfo.hasDependencies(mightHaveDependencies(result));
                    if (opts.supportsArchive) {
                        deleteInfo.deleteAction("Archive");
                    } else if (opts.supportsReassign && mightHaveDependencies(result)) {
                        deleteInfo.deleteAction("Reassign");
                    }
                    else {
                        deleteInfo.deleteAction("Delete");
                    }
                    $("#" + opts.deleteDialogId).modal("show");
                    Controls.clearBusy(sourceButton);
                }
            }).fail(errorDetails => {
                Controls.clearBusy(sourceButton);
                Service.reportMessageResultError(errorDetails);

            });
        };

        function loadDialog(entity?, index?) {
            if (entity) {
                $("#" + opts.editDialogGridIndexInputId).val(index);
            } else {
                $("#" + opts.editDialogGridIndexInputId).val("");
            }
            if (opts.fnPopulateEditFormWithEntity) {
                opts.fnPopulateEditFormWithEntity(entity);
            }
        }

        function addEntity() {
            loadDialog(null);
            $("#" + opts.editDialogTitleId).html(`${opts.addEntityDialogTitle}`);
            $("#" + opts.editDialogId).modal("show");
            lastFocus = $("#" + opts.addEntityButtonId);
            return false;
        }

        that.editEntity = (entityId, entityIndex, activatingElement) => {
            if (opts.entityDataTable) {
                if (activatingElement) {
                    lastFocus = activatingElement;
                }
                //var data = opts.entityDataTable.fnGetData(entityIndex);
                var data = opts.entityDataTable.settings().row(entityIndex).data();
                loadDialog(data, entityIndex);
                $("#" + opts.editDialogTitleId).html(`${opts.editEntityDialogTitle}`);
                $("#" + opts.editDialogId).modal("show");
            }
        };
        function closeDialog() {
            $("#" + opts.editDialogId).modal("hide");
        }
        function saveEntityInEditor() {
            var form = $("#" + opts.editFormId);
            if (form && form.length) {
                if (!form.data("submitting")) {
                    var index = parseInt($("#" + opts.editDialogGridIndexInputId).val().toString(), 10);
                    if (form.valid()) {
                        Controls.setBusy("#" + opts.editFormId + " button[type='submit']");
                        form.data("submitting", true);
                        var formData = new FormData(<HTMLFormElement>form[0]);
                        $.ajax({
                            url: opts.saveUrl,
                            type: 'POST',
                            data: formData,
                            cache: false,
                            contentType: false,
                            processData: false
                        }).done((result: any) => {
                            if (result && (result).Successful) {
                                if (opts.entityDataTable) {
                                    if (_.isNumber(index) && !_.isNaN(index)) {
                                        //opts.entityDataTable.fnUpdate(result.Data, index);
                                        opts.entityDataTable.settings().row(index).data(result.Data).draw();
                                    } else {
                                        //index = opts.entityDataTable.fnAddData(result.Data)[0];
                                        opts.entityDataTable.settings().row.add(result.Data).draw();
                                        index = opts.entityDataTable.settings().data().indexOf(result.Data);
                                    }
                                    flashRowAtIndex(index);
                                }
                                closeDialog();
                                updateComplete(result.Data);
                            } else {
                                Service.reportMessageResultError(result);
                            }
                            Controls.clearBusy("#" + opts.editFormId + " button[type='submit']");
                            form.data("submitting", false);

                        }).fail(errorDetails => {
                            Controls.clearBusy("#" + opts.editFormId + " button[type='submit']");
                            Service.reportMessageResultError(errorDetails);
                            form.data("submitting", false);
                        });
                        /*   $.post(opts.saveUrl, form.serialize(), function (result) {
                               if (result && result.Successful) {
                                   if (opts.entityDataTable) {
                                       if (_.isNumber(index) && !_.isNaN(index)) {
                                           opts.entityDataTable.fnUpdate(result.Data, index);
                                       } else {
                                           index = opts.entityDataTable.fnAddData(result.Data);
                                       }
                                       flashRowAtIndex(index);
                                   }
                                   closeDialog();
                                   updateComplete(result.Data);
                               } else {
                                   atlas.cms.service.reportMessageResultError(result);
                               }
                               atlas.cms.controls.clearBusy("#" + opts.editFormId + " button[type='submit']");
                               form.data("submitting", false);
                           }).fail(function (errorDetails) {
                               atlas.cms.controls.clearBusy("#" + opts.editFormId + " button[type='submit']");
                               atlas.cms.service.reportMessageResultError(errorDetails);
                               form.data("submitting", false);
                           });*/
                    }
                }
            }
            return false;
        }

        var lastFocus = null;
        var deleteRowButtonSelector = null;
        var deleteRowDOMIndex = null; //DOM row index for row being deleted

        function initializeDialogs() {
            $("#" + opts.addEntityButtonId).on("click", addEntity);
            var validator;
            if (opts.errorPlacementFunction) {
                validator = $("#" + opts.editFormId).validate({ submitHandler: saveEntityInEditor, errorPlacement: opts.errorPlacementFunction });
            } else {
                validator = $("#" + opts.editFormId).validate({ submitHandler: saveEntityInEditor });
            }
            $("#" + opts.editDialogId).on('shown.bs.modal', e => {
                $("#" + opts.editDialogId).find("input[type!='hidden'],textarea:not([disabled]),select:not([disabled])").first().focus();
                if (e.relatedTarget) { //the triggering element is only available when clicked by the user
                    lastFocus = e.relatedTarget;
                }
            });
            $("#" + opts.editDialogId).on('hide.bs.modal', e => {
                validator.resetForm();
                $("#" + opts.editFormId).find(".has-error").removeClass("has-error");
            });
            $("#" + opts.editDialogId).on('hidden.bs.modal', e => {
                if (lastFocus)
                    $(lastFocus).focus();
                lastFocus = null;

                if (opts.dialogDismissCallback)
                    opts.dialogDismissCallback();
            });
            $("#" + opts.deleteDialogId).on("shown.bs.modal", e => {
                if ($("#" + opts.deleteDialogId).find("input[type!='hidden']")) {
                    $("#" + opts.deleteDialogId).find("input[type!='hidden']").first().focus();
                } else {
                    $("#" + opts.deleteDialogId).find("button:not([disabled])").first().focus();
                }
            });
            $("#" + opts.deleteDialogId).on("hidden.bs.modal", e => {
                setFocusAfterDeleteAction();
            });
        }

        function setFocusAfterDeleteAction() {
            //We're setting the focus state to the same row/line as the deleted row so user is the same relative place.
            if (deleteRowDOMIndex != null && deleteRowButtonSelector) {
                var domTable = <HTMLTableElement>opts.entityDataTable.settings().table(0).node();
                if (domTable.rows.length > 0) {
                    if (deleteRowDOMIndex >= domTable.rows.length) {
                        deleteRowDOMIndex = domTable.rows.length - 1;
                    }
                    var deleteRow = domTable.rows[deleteRowDOMIndex];
                    var deleteBtn = $(deleteRow).find(deleteRowButtonSelector);
                    deleteBtn.focus();
                } else {
                    //all rows deleted; set the focus to the add/edit button
                    $("#" + opts.addEntityButtonId).focus();
                }
            }
            deleteRowButtonSelector = null;
            deleteRowDOMIndex = null;
        }

        function init() {
            initializeDialogs();
            ko.applyBindings(deleteInfo, $("#" + opts.deleteDialogId)[0]);
        }

        init();

        return that;
    }
}